export default __webpack_public_path__ + "images/8ee467a477febf452a797ff8f262cf95.png";